<template>
  <div class="loanApplicationPage">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field v-model="propertyData.applicantIdName" readonly label="借款人：" class="ggInput" />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="propertyData.amount"
          class="ggInput"
          input-align="right"
          readonly
          type="number"
          v-enterIntNumber
          label="申请金额（元）："
          placeholder="请输入...  "
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary" v-if="propertyData.paymentTypeName!=null">
        <van-field v-model="propertyData.paymentTypeName" readonly class="ggInput" label="付款方式：" />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary" v-if="propertyData.paymentType == 'zz' && propertyData.bankAccount!=null">
        <van-field
          v-model="propertyData.bankAccount"
          placeholder="请输入...  "
          readonly
          class="ggInput"
          label="开户银行："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary" v-if="propertyData.paymentType == 'zz'  && propertyData.depositBank!=null">
        <van-field v-model="propertyData.depositBank" readonly class="ggInput" label="银行账户：" />
      </van-cell-group>
      <!-- 所属项目 -->
      <van-cell-group class="itemSite baseNone beizhu" v-if="projectName != null">
        <van-field
          v-model="projectName"
          type="textarea"
          label="所属项目："
          readonly
          input-align="right"
          rows="1"
          autosize
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.purpose"
          class="ggInput"
          input-align="right"
          readonly
          rows="1"
          autosize
          type="textarea"
          label="借款用途："
        />
      </van-cell-group>
      <!-- 附件 -->
     <!-- 微信的附件 避免和原生交互 -->
    <wx-file-view
      v-if="is_weixn"
      :filesData="propertyData"
      :editType="editType"
      class="fileview"
    ></wx-file-view>
    <!-- 原生附件 -->
    <file-view
      v-else
      :filesData="propertyData"
      :editType="editType"
      @changeFile="changebaseAnnexes"
      class="fileview"
    ></file-view>
    </div>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
  <script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { dateFormat, isEdit } from "@/utils/common";
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const refreshPage = () => import("@/components/common/refreshPage");
import { getDeviceType, closePage,is_wei, } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "loanApplication-detail",
  props: {
    id: {
      //借款记录id
      type: String,
      default: ""
    }
  },
  data() {
    return {
      propertyData: {
        applicantIdName: "", //名称
        projectId: "", //所属项目code
        amount: "", //借款金额
        purpose: "", //借款用途
        bankAccount: "", //开户银行
        collectingCompany: "", //s收款单位
        depositBank: "", // 银行账号
        paymentTypeName: "", //付款方式name
        paymentType: "", //付款方式code
        verifyStatus: "hold",
        baseAnnexes: [] //附件
      },
      projectName: "", //所属项目名称
      commonId: "",
      editType: false,
      refreshPage: false, // 网络请求失败时显示
      is_weixn:is_wei(),//是否为微信
    };
  },
  mounted() {
    if(is_wei()){
      document.title="借款申请";
    }
    this.commonId = this.id; //申请Id
    this.$nextTick(() => {
      this.initPage();
    });
  },
  components: {
    refreshPage,
    fileView,
    wxFileView
  },
  methods: {
    //监测附件方法
    changebaseAnnexes(data) {
      this.propertyData.baseAnnexes = data;
    },
    initPage() {
      let _this = this;
      _this.$api.finance.borrow
        .detail(_this.commonId)
        .then(res => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            _this.projectName = res.data.projectName;
            _this.propertyData.paymentTypeName =
              res.data.paymentType == "zz" ? "转账" : res.data.paymentType == "xj"?"现金":
              res.data.paymentType == "hp"
                ? "汇票":"保函";
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
  <style lang="less">
.loanApplicationPage {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  .dwBox {
    .van-cell {
      .van-cell__title {
        width: 150px;
      }
    }
  }
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
    // overflow-y: initial;
  }
  #searchHeight {
    text-align: left;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
}
</style>